import { WebpUrl } from '@didi/webx-js-core';
class WebpUrlWeb extends WebpUrl {
    constructor() {
        super();
    }
    checkWebp(url) {
        return !window.__CAN_WEBP__ ? url : 'next';
    }
}
const webpUrlWeb = new WebpUrlWeb();
const webpUrl = webpUrlWeb.getWebpUrl.bind(webpUrlWeb);
export default webpUrl;
